export default __webpack_public_path__ + "images/orange-cash.c702b62c2f2ebf693d7ca25edb12ec6d.jpeg";